import api from './client';

interface IContactResponse {
    "ID": number;
    "UserID": number;
    "AssistantID": number;
    "DateAdd": string;
    "Channel": string;
    "CustomName": string;
    "Metadata": {
        "tgFirstName": string;
        "tgID": string;
        "tgLanguageCode": string;
        "tgLastName": string;
        "tgUsername": string;
    },
    "name": string;
    "sessions_count": number;
    "new_sessions_count": number;
    "last_message_date": string;
}

export interface IMessageResponse {
    "ID": number;
    "UserID": number;
    "AssistantID": number;
    "ScenarioID": number;
    "StepID": number;
    "StepNumber": number;
    "ContactID": number;
    "Content": string;
    "Context": number;
    "GPTResponse": string;
    "Role":  string;
    "DateAdd": string;
    "IsRead": boolean;
}

export const contactsApi = {
    getAll: (id: string) =>
        api.get<IContactResponse[]>('/contacts/' + id),
    getOne: (id: number) =>
        api.get<IContactResponse>('/contact/' + id),
    getSession: (assistantId: string, id: string) =>
        api.get<IMessageResponse[]>('/logs/' + assistantId + '?contact_id=' + id),
    getSessionSummary: (assistantId: string, id: string) =>
        api.get<string>('/sessions_summary/' + assistantId + '?contact_id=' + id),
    setAsRead: (body: { id: number }) =>
        api.put('/logs_is_read', body),
    changeUserName: (id: string, name: string) =>
        api.put('/contact/' + id, { custom_name: name }),
    clearLog: (assistantId: string, contactId: string) =>
        api.delete('/logs_cleanup', {
            data: {
                contact_id: Number(contactId),
                assistant_id: Number(assistantId)
            }
        })
};
